module.exports = __webpack_public_path__ + "img/iDEAFP-logo.3e4c14f9.jpg";